/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MerchantSiteMerchantTypeViewModel } from '../../models/merchant-site-merchant-type-view-model';
import { ServedCustomerSegmentResponse } from '../../models/served-customer-segment-response';

export interface CalculateServedCustomerSegments$Params {
      body: Array<MerchantSiteMerchantTypeViewModel>
}

export function calculateServedCustomerSegments(http: HttpClient, rootUrl: string, params: CalculateServedCustomerSegments$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ServedCustomerSegmentResponse>>> {
  const rb = new RequestBuilder(rootUrl, calculateServedCustomerSegments.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ServedCustomerSegmentResponse>>;
    })
  );
}

calculateServedCustomerSegments.PATH = '/merchants/sites/calculate-servable-customer-segments';
